import React from 'react';
import { IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import { Title, Spacer, NormalText, Subtitle, StrongText, SmallText } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { checkmark, checkmarkCircle, chevronBackOutline, chevronForwardOutline, informationCircleOutline, lockClosed, lockClosedOutline } from 'ionicons/icons';
import { getMilestoneRewardsInfo } from '../../store/actions';
import Slider, { Slide } from '../../components/slider';

const RewardItem = ({ reward, id, __ }) => {
	return (
		<div className="loyalty-reward pointer" style={{ backgroundImage: `url(${reward.reward.image})` }}>
			<div className='loyalty-next-reward'>
				<IonIcon icon={lockClosedOutline} />
				<NormalText>{__('Next reward')}</NormalText>
			</div>
			<div className="loyalty-reward-name">
				<StrongText className="block">{reward.name}</StrongText>
				<NormalText>{`${__('Unlock at')} ${reward.stamps_required} ${__('points')}`}</NormalText>
			</div>
		</div>
	);
};
class MilestoneRewards extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedReward: null,
			rewardInfoModalOpen: false,
		};

	}
	componentDidMount() {
		this.props.dispatch(getMilestoneRewardsInfo());
	}
	getMilestoneRewardsData = (rewards, balance) => {
		rewards.sort((a, b) => a.stamps_required - b.stamps_required)
		const balanceRequiredTotal = rewards.reduce((acc, el) => acc + el.stamps_required, 0);

		let nextRewardPoints = 0;
		let foundNext = false;

		const data = rewards.map(item => {
			let filled;

			if (balance >= item.stamps_required) {
				filled = 100;
			} else if (balance > 0) {
				filled = +(balance / item.stamps_required * 100).toFixed(2);
				if (!foundNext) {
					nextRewardPoints = item.stamps_required - balance;
					foundNext = true;
				}
				balance = 0;
			} else {
				filled = 0;
				if (!foundNext) {
					nextRewardPoints = item.stamps_required;
					foundNext = true;
				}
			}

			return {
				...item,
				percentageFilled: `${Math.floor(filled)}%`,
				percentage: `${(item.stamps_required / balanceRequiredTotal * 100).toFixed(2)}%`,
				display: item.stamps_required > balance
			};
		});

		return {
			rewards: data,
			nextRewardPoints
		};
	};
	render() {
		const { __, lifetime_balance, milestoneInfo } = this.props;
		const { rewardInfoModalOpen } = this.state;
		const { rewards, nextRewardPoints } = this.getMilestoneRewardsData(this.props.rewards, lifetime_balance)
		return (
			<>
				<div className='milestone-wrapper box-wrapper'>
					<div className='milestone-header'>
						<StrongText>{__('Lifetime points earned')}</StrongText>
						<div style={{ display:'flex',alignItems:'center',gap:'12px' }}>

							<StrongText className='primary-color'>{lifetime_balance} </StrongText>
							<IonIcon
								className='text-color'
								style={{ cursor: 'pointer', height: '25px', width: '25px' }}
								onClick={() => {
									this.setState({ rewardInfoModalOpen: true });
								}}
								icon={informationCircleOutline}
							/>
						</div>

					</div>
					{nextRewardPoints > 0 &&
						<>
							<div className='milestone-progress-wrapper'>
								<div>
									<StrongText>{__('Next reward')}</StrongText>
									<StrongText>{`${nextRewardPoints} ${__('points away')}`}</StrongText>
								</div>
								<div className='milestone-progress-bar'>{
									rewards.map(el => (
										<div data-percentagefilled={el.percentageFilled} style={{ width: el.percentage }}>
											<span style={{ width: el.percentageFilled }}></span>
										</div>
									))}</div>
							</div>
							<div style={{ overflow: 'hidden', display: 'block' }} className="loyalty-rewards-wrapper"
							>

								<Slider
									settings={{
										slidesPerView: rewards.filter(reward => reward.display).length == 1 ? 1 : 1.3,
										spaceBetween: 10,
										slidesOffsetBefore: 0,
										centeredSlides: false,
									}}
								>
									{rewards.filter(reward => reward.display).map((reward, index) => (
										<Slide className={`${rewards.length == 1 ? 'single-slide' : ''}`} >
											<RewardItem key={'rw-' + index} reward={reward} __={__} available_balance={lifetime_balance} />

										</Slide>
									))}
								</Slider>
							</div>
						</>
					}
				</div>
				<Modal
					className="loyalty-faq-modal"
					isOpen={rewardInfoModalOpen}
					onDidDismiss={() => {
						this.setState({ rewardInfoModalOpen: false });
					}}
				>
					<div className="lefted">
						<Title className='modal-title'>{__('Milestone Rewards')}</Title>
						<div dangerouslySetInnerHTML={{ __html: milestoneInfo }}></div>
					</div>{' '}
				</Modal>
			</>
		);
	}
}
const stateToProps = (state) => {
	const { profile, auth } = state.profile;

	return {
		vouchers: state.profile.vouchers || [],
		qr_code: state.profile.profile.qr_code,
		profile,
		auth,
		milestoneInfo: state.common.milestoneInfo,
	};
};

export default connect(stateToProps)(withTranslation(MilestoneRewards));
